module.exports = __webpack_public_path__ + "img/joinDotStraightWhite.3a901e2e.svg";